import { render, staticRenderFns } from "./ChildActivityConfigParameterDialog.vue?vue&type=template&id=a4eaa1ba&scoped=true"
import script from "./ChildActivityConfigParameterDialog.vue?vue&type=script&lang=js"
export * from "./ChildActivityConfigParameterDialog.vue?vue&type=script&lang=js"
import style0 from "./ChildActivityConfigParameterDialog.vue?vue&type=style&index=0&id=a4eaa1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4eaa1ba",
  null
  
)

export default component.exports